<template>
    <div>
        <!-- opened-sifarnik - na root ako nema parrenta -->
        <!--  -->
        <div @click="showChildren=!showChildren" class="sifarnik-item opened-sifarnik" :style="indent(1)"
            v-if="sifra.children.length > 0 || sifra.parrent_id == null">
            <div class="sifarnik-item-left">
                <div class="sifarnik-item-no">{{sifra.number}}</div>
                <div class="sifarnik-item-title">{{sifra.name}}</div>
            </div>
            <div class="sifarnik-item-right">
                <div class="sifarnik-edit add-button add-pen" @click.stop="newFromParrent(sifra.uid)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                        <g>
                            <g>
                                <path fill="#0acab1"
                                    d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" />
                            </g>
                        </g>
                    </svg>
                </div>
                <div class="sifarnik-edit add-button add-pen" @click.stop="editSingle(sifra)"><svg
                        xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                        <g>
                            <g>
                                <path fill="#7b7b8a"
                                    d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z" />
                            </g>
                        </g>
                    </svg></div>
                <div class="sifarnik-delete" v-if="sifra.children.length==0" @click="deleteSingle(sifra)"><svg
                        xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15">
                        <g>
                            <g>
                                <path fill="#7b7b8a"
                                    d="M11.934 3.295v.918a.459.459 0 0 1-.459.46H.46A.459.459 0 0 1 0 4.212v-.918c0-.634.514-1.147 1.148-1.147h2.524v-.46c0-.76.617-1.376 1.377-1.376h1.836c.76 0 1.377.616 1.377 1.377v.459h2.525c.633 0 1.147.513 1.147 1.147zM4.59 2.148h2.754v-.46a.46.46 0 0 0-.459-.458H5.05a.46.46 0 0 0-.459.459zm6.473 3.442c.082 0 .147.069.144.15l-.38 7.948A1.375 1.375 0 0 1 9.453 15h-6.97c-.736 0-1.34-.576-1.375-1.312l-.38-7.947a.143.143 0 0 1 .144-.15zm-3.26 7.115a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0zm-2.295 0a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0zm-2.295 0a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0z" />
                            </g>
                        </g>
                    </svg>
                </div>
                <div v-else class="sifarnik-empty"></div>
            </div>
        </div>
        <div v-else class="sifarnik-item-details-wrapper" :style="indent(2)">
            <div class="sifarnik-under-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="24"
                    viewBox="0 0 22 24">
                    <g>
                        <g>
                            <path fill="#a2a4b0"
                                d="M20.904 17.081l-6.632 6.637a1.008 1.008 0 0 1-1.428-1.424l4.925-4.927H7.672c-3.784 0-6.872-3.077-6.885-6.86V1.268a1.007 1.007 0 1 1 2.016 0v9.234a4.876 4.876 0 0 0 4.869 4.849h10.077l-4.906-4.908a1.008 1.008 0 1 1 1.428-1.425l6.632 6.638a1.007 1.007 0 0 1 0 1.424z" />
                        </g>
                    </g>
                </svg></div>
            <div class="sifarnik-item-details">
                <div class="sifarnik-item-left">
                    <div class="sifarnik-item-no">{{sifra.number}}</div>
                    <div class="sifarnik-item-detail-title">{{sifra.name}}</div>
                </div>

                <div class="sifarnik-item-right">
                    <div class="sifarnik-amount" v-if="sifra.value != 0">{{sifra.value}}</div>
                    <div class="sifarnik-edit add-button add-pen" @click.stop="newFromParrent(sifra.uid)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                            <g>
                                <g>
                                    <path fill="#0acab1"
                                        d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" />
                                </g>
                            </g>
                        </svg>
                    </div>
                    <div class="sifarnik-edit add-button add-pen" @click.stop="editSingle(sifra)"><svg
                            xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                            <g>
                                <g>
                                    <path fill="#7b7b8a"
                                        d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z" />
                                </g>
                            </g>
                        </svg></div>
                    <div class="sifarnik-delete" @click="deleteSingle(sifra)"><svg xmlns="http://www.w3.org/2000/svg"
                            width="12" height="15" viewBox="0 0 12 15">
                            <g>
                                <g>
                                    <path fill="#7b7b8a"
                                        d="M11.934 3.295v.918a.459.459 0 0 1-.459.46H.46A.459.459 0 0 1 0 4.212v-.918c0-.634.514-1.147 1.148-1.147h2.524v-.46c0-.76.617-1.376 1.377-1.376h1.836c.76 0 1.377.616 1.377 1.377v.459h2.525c.633 0 1.147.513 1.147 1.147zM4.59 2.148h2.754v-.46a.46.46 0 0 0-.459-.458H5.05a.46.46 0 0 0-.459.459zm6.473 3.442c.082 0 .147.069.144.15l-.38 7.948A1.375 1.375 0 0 1 9.453 15h-6.97c-.736 0-1.34-.576-1.375-1.312l-.38-7.947a.143.143 0 0 1 .144-.15zm-3.26 7.115a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0zm-2.295 0a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0zm-2.295 0a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0z" />
                                </g>
                            </g>
                        </svg></div>
                </div>
            </div>
        </div>
        <div v-show="showChildren" v-if="sifra.children != null">
            <single-sifra v-for="(single,key) in sifra.children" :key="key" :sifra="single" :depth="depth+1"
                @edit-single="editSingle" @add-parent="newFromParrent" @delete-single="deleteSingle" />

        </div>


    </div>
</template>
<script>
import SingleSifra from "@/components/costSheetComponents/sifarnik/SingleSifra.vue";


export default {
    name: "single-sifra",
    props: ["sifra", "depth"],
    data(){
        return{
            showChildren:true,
        }
    },
    components: {
        SingleSifra
    },
    computed: {
        // indent() {
        //     var sirina = (86 - (this.depth*4)) + "rem";
        //     var margin = (4*this.depth)+"rem";
        //     return { width: sirina, marginLeft : margin };
        // },
    },
    methods: {
        indent(type) {
            if (type == 1) {
                var sirina = (86 - (this.depth * 4)) + "rem";
                var margin = (4 * this.depth) + "rem";
                return { width: sirina, marginLeft: margin };
            }else{
                var sirina = (86 - ((this.depth-1) * 4)) + "rem";
                var margin = (4 * (this.depth-1)) + "rem";
                return { width: sirina, marginLeft: margin };
            }

        },
        editSingle: function (node) {
            this.$emit("edit-single", node);
        },
        newFromParrent(uid) {
            this.$emit("add-parent", uid);
        },
        deleteSingle: function (node) {
            console.log("Deleteing single")
            this.$emit("delete-single", node);
        }
    }
}

</script>
  
<style>

</style>